export class RestoreDbToRdsSnapshotRequest {
    'restoreAccountId';
    'restoreRegion';
    'encryptionKeyId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "restoreRegion",
            "baseName": "restoreRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDbToRdsSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
